// ============================================================
// Teacher Classwork Mock Data
// ============================================================

export const mockTeacherClasswork = [
  {
    id: 'cw-1',
    teacherId: 'teacher-1',
    schoolId: 'school-1',
    classId: 'class-1',
    className: 'Grade 1',
    sectionId: 'sec-1',
    sectionName: 'Section A',
    subject: 'Mathematics',
    date: '2026-07-21',
    topicCovered: 'Introduction to 2D Shapes',
    remarks: 'Most students understood the concept well. Need to revise triangles tomorrow.',
  },
  {
    id: 'cw-2',
    teacherId: 'teacher-1',
    schoolId: 'school-1',
    classId: 'class-1',
    className: 'Grade 1',
    sectionId: 'sec-2',
    sectionName: 'Section B',
    subject: 'Mathematics',
    date: '2026-07-21',
    topicCovered: 'Number line addition (1-20)',
    remarks: 'Completed exercises 1-5 in class. Gave worksheet for remaining.',
  },
  {
    id: 'cw-3',
    teacherId: 'teacher-2',
    schoolId: 'school-1',
    classId: 'class-2',
    className: 'Grade 2',
    sectionId: 'sec-3',
    sectionName: 'Section A',
    subject: 'Science',
    date: '2026-07-21',
    topicCovered: 'Living vs Non-Living Things',
    remarks: 'Conducted a small activity outside the classroom to identify objects.',
  },
];
